<template>
  <div class="header-area">
    <div class="user-info" @click="handleUserClick">
      <template v-if="isLogin">
        <img :src="userInfo.avatar.m" class="avatar" />
        <p class="user-name">{{ userInfo.nickname }}</p>
      </template>
      <template v-else>
        <img src="../../assets/v2/unlogin.png" class="avatar unlogin"/>
        <p class="user-name login-text">立即登录</p>
      </template>
    </div>
    <div class="rules" @click="handleRules">
      <p>规则说明</p>
      <p class="rules-tip-icon"></p>
    </div>

    <!-- 规则说明弹窗 -->
    <m-dialog
      v-model="showRules"
      title="规则说明"
      :show-footer="false"
      :append-to-body="true"
      content-class="rules-content"
      @close="handleDialogClose"
    >
      <div v-if="!isNoneCashVer">
        <p>参与本次活动之前，请您详细阅读并知悉本活动规则及相关条款，<strong>即视为用户已阅读、理解、并同意活动规则及特别提示全部内容，<span class="rules-red">如您介意，请谨慎参与。</span></strong></p>
        <br>
        <p class="title">活动概述：</p>
        <p>1、奖励中心目前上线了现金任务和积分任务，完成签到、邀请好友、浏览页面等任务，即可获得平台的一定的现金奖励或积分奖励，具体任务和具体奖励数额以活动页面公示条款为准。</p>
        <p>2、因整体产品活动处于测试试点阶段，活动期间可能部分区域部分用户无法参与活动，具体以用户产品页面显示的活动详情为准，以上敬请谅解。</p>
        <br>
        <p class="title">一．签到任务</p>
        <p>1、用户可以每天访问奖励中心参与签到拆盲盒活动，盲盒的类型有随机金额现金、积分等。开出的盲盒有一定随机性，也可能不中奖(展示谢谢参与)，具体以弹窗展示结果为准。</p>
        <p>2、签到每7天为1个周期，完成连续签到任务，有机会获得大额现金奖励，若途中断签则从第1天开始重新计算。</p>
        <p>3、签到红包开出的现金奖励将直接打入活动页面账户内。</p>
        <br>
        <p class="title">二．邀请任务</p>
        <p>1、邀请人每成功邀请一个新用户且新用户在绑定邀请关系当天在芒果TV累计观看至少1分钟视频后，邀请人即可获得一定现金奖励，具体金额以活动页面公示为准；被邀请人在第2-7天观看2个及以上视频且总时长大于10分钟，即视为助力成功，邀请人将得到对应的现金奖励，具体奖项设置、金额以活动页面公示为准。邀请人每天可邀请多位新用户完成助力，将累计获得对应现金奖励，有数量限制(具体数量限制以活动页面公示为准) </p>
        <p>2、关于平台新用户的定义：被邀请人首次使用新的移动设备下载芒果TV APP，并注册芒果TV新账号，登录使用芒果TV APP。如不满足，则不视为新用户。</p>
        <p>3、特别提示：如新用户和邀请人一方存在违反法律法规、行业监管政策条例/规则的规定或芒果TV平台规则、违背诚实信用原则的行为，双方均无法获得现金或其他奖励。</p>
        <br>
        <p class="title">三．现金任务</p>
        <p>1、用户每天通过站内相关入口进入奖励中心做现金任务，按照要求完成任务后方可领取现金奖励。</p>
        <p>2、完成任务获得的现金奖励，在领取后将在现金账户中展示，用户可在【现金明细】中查看明细。</p>
        <p>3、部分任务奖励金额随机发放，任务描述中仅展示随机奖励可能获得的最高金额。</p>
        <p>4、完成现金任务后，现金不会自动到账，需要用户<strong>手动领取</strong>现金奖励，请于任务完成后当天的23点59分前领取，逾期未领取将视为用户主动放弃权益，平台方不承担任何补偿/赔偿责任。</p>
        <p>5、<strong>连续14天未访问“奖励中心”，提现余额将被清零</strong>。</p>
        <br>
        <p class="title">四．提现规则</p>
        <p>1、现金奖励累计到一定金额后(大于0.1元)可提现至微信零钱，每人每天至多可提现1次。</p>
        <p>2、每天的提现时间段为<strong>9点-23点</strong>，非此时间段不可提现。</p>
        <p>3、<strong>根据国家法律法规政策规定，为您在活动期间获得的收入缴纳相关税费，选择固定金额提现，需扣除20%的税费，选择随机提现，税费由活动承担，无需扣除税费</strong>。</p>
        <p>4、用户参与活动账号需绑定微信账号方可进行提现操作，且绑定的微信必须通过实名认证，才可提现到微信零钱。</p>
        <p>5、提现金额打款过程中，因参与人数过多，可能导致到账时间有所延迟，请您耐心等待。</p>
        <br>
        <p class="title">五．积分任务</p>
        <p>1、用户每日进入奖励中心做积分任务，完成任务后可领取积分奖励，用户可在【积分明细】中查看明细。</p>
        <p>2、完成积分任务后，积分不会自动到账，需要用户手动领取积分，请于当天的23点59分前领取，逾期未领取视为用户主动放弃权益，平台方不承担任何补偿/赔偿责任。</p>
        <p>3、积分将于每年的年底对前一年获取的积分余额进行清零，时间一般为每年12月25日左右，每一年具体的清零时间以官方公告为准。</p>
        <p>4、积分可以用于兑换各类权益，如积分商城会员卡、实物商品、会员点映礼内容等，还可以用于参与站内抽奖活动，具体以活动页面展示为准。</p>
        <br>
        <p class="title">六．其他</p>
        <p>1、每个用户仅限使用1个账号参与本次活动(同一芒果TV账号、手机号、移动设备、银行卡、支付账号、身份证以及其他信息相同均视为同一账号)。</p>
        <p>2、虚拟手机号无法参与本次活动。</p>
        <p>3、被封禁用户无法参与本次活动。</p>
        <p>4、如用户曾经存在、出现或经芒果TV合理怀疑存在违背诚实信用原则的行为，芒果TV有权采取撤消活动资格、奖励审核不通过、限制提现/兑换、账号金额清零、限制登录、封禁账号、限制再次注册使用等措施，亦有权收回用户已领取的现金或积分、追讨已提现/领取的金额或已兑换的金额或与奖品同等价值的金额，并保留追究该用户责任的权利。违背诚实信用原则的行为包括但不限于下载非官方客户端;使用高危作弊嫌疑的手机号;使用模拟器、插件、外挂、APP分身软件等非法工具扫码、下载、安装、注册、登录、赠与、领取金币或积分、兑换;使用同一移动设备反复注册登录多个账号;篡改设备数据;恶意牟利等扰乱平台秩序;使用插件、外挂、群控系统或第三方工具对本平台及本活动进行干扰、破坏、修改或施加其他影响及本平台认为的其他不正当手段。如因此给用户造成损失，本平台不进行任何赔偿或补偿。</p>
        <p>5、如果出现因网络攻击、黑客攻击等原因导致活动无法继续，芒果TV有权利提前终止活动。</p>
        <p>6、活动期间用户卸载客户端或退出登录或关闭APP页面或更换账号登录设备，有可能导致已领取的奖励信息或正在进行的任务进度丢失，请谨慎操作。</p>
        <p>7、在法律允许的范围内，芒果TV有权对本活动规则进行变动或调整。相关变动或调整将公布在活动规则页面上，并于公布时即时生效，用户继续参与该活动则视为对前述变动或者调整后的活动规则予以同意。如果用户拒绝上述活动规则的变更或者调整，应停止参与变更后的该活动。</p>
        <p>8、如有疑问，您可进入芒果TV app点击“我的”——“帮助与客服”寻求在线人工客服帮助。</p>
        <p>9、本规则涉及的一切时间均以东八区区时（即北京时间）为准。</p>
      </div>
      <div v-else>
        <p>参与本次活动之前，请您详细阅读并知悉本活动规则及相关条款，如您参与本活动，<strong>即视为用户已阅读、理解、并同意活动规则及特别提示全部内容，如您介意，请谨慎参与。</strong></p>
        <br>
        
        <p class="title">一．活动概述：</p>
        <p>1、用户每日进入积分中心做积分任务，完成任务后可领取积分奖励，用户可在【积分明细】中查看明细。</p>
        <p>2、完成积分任务后，积分不会自动到账，需要用户手动领取积分，请于当天的23点59分前领取，逾期未领取视为用户主动放弃权益，平台方不承担任何补偿/赔偿责任。</p>
        <p>3、积分将于每年的年底对前一年获取的积分余额进行清零，时间一般为每年12月25日左右，每一年具体的清零时间以官方公告为准。</p>
        <p>4、积分可以用于兑换各类权益，如积分商城会员卡、实物商品、会员点映礼内容等，还可以用于参与站内抽奖活动，具体以活动页面展示为准。</p>
        <br>

        <p class="title">二．其他：</p>
        <p>1、每个用户仅限使用1个账号参与本次活动(同一芒果TV账号、手机号、移动设备、银行卡、支付账号、身份证以及其他信息相同均视为同一账号)。 </p>
        <p>2、虚拟手机号无法参与本次活动。</p>
        <p>3、被封禁用户无法参与本次活动。</p>
        <p>4、如用户曾经存在、出现或经芒果TV合理怀疑存在违背诚实信用原则的行为，芒果TV有权采取撤消活动资格、奖励审核不通过、限制提现/兑换、账号金额清零、限制登录、封禁账号、限制再次注册使用等措施，亦有权收回用户已领取的现金或积分、追讨已提现/领取的金额或已兑换的金额或与奖品同等价值的金额，并保留追究该用户责任的权利。违背诚实信用原则的行为包括但不限于下载非官方客户端;使用高危作弊嫌疑的手机号;使用模拟器、插件、外挂、APP分身软件等非法工具扫码、下载、安装、注册、登录、赠与、领取金币或积分、兑换;使用同一移动设备反复注册登录多个账号;篡改设备数据;恶意牟利等扰乱平台秩序;使用插件、外挂、群控系统或第三方工具对本平台及本活动进行干扰、破坏、修改或施加其他影响及本平台认为的其他不正当手段。如因此给用户造成损失，本平台不进行任何赔偿或补偿。</p>
        <p>5、如果出现因网络攻击、黑客攻击等原因导致活动无法继续，芒果TV有权利提前终止活动。</p>
        <p>6、活动期间用户卸载客户端或退出登录或关闭APP页面或更换账号登录设备，有可能导致已领取的奖励信息或正在进行的任务进度丢失，请谨慎操作。</p>
        <p>7、在法律允许的范围内，芒果TV有权对本活动规则进行变动或调整。相关变动或调整将公布在活动规则页面上，并于公布时即时生效，用户继续参与该活动则视为对前述变动或者调整后的活动规则予以同意。如果用户拒绝上述活动规则的变更或者调整，应停止参与变更后的该活动。</p>
        <p>8、如有疑问，您可进入芒果TV app点击“我的”——“帮助与客服”寻求在线人工客服帮助。</p>
        <p>9、本规则涉及的一切时间均以东八区区时（即北京时间）为准。</p>
      </div>
    </m-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { loginMixin } from '@/utils/mixin'
import MDialog from '../dialog/index.vue'

export default {
  components: {
    MDialog
  },
  mixins: [loginMixin],
  data() {
    return {
      showRules: false
    }
  },
  computed: {
    ...mapState(['userInfo', 'isNoneCashVer']),
    ...mapGetters(['isLogin']),
  },
  methods: {
    handleUserClick() {
      const wrappedHandler = this.$wrapClick(() => {
        // 已登录状态下不需要做任何事
        // 测试sentry 日志
        console.error('TEST ERROR');
      });
      wrappedHandler();
    },
    handleRules() {
      // 查看规则不需要登录检查
      this.showRules = true
    },
    handleDialogClose() {
      this.showRules = false
    }
  }
}
</script>

<style scoped lang="less">
  @import './index.less';
</style>